import { useState } from 'react';
import { StandardButton } from '../atoms/buttons';
import { HorizontalLayout } from './layout';
import { Badge } from '../atoms/badges';
import { Spinner } from '../atoms/spinner';

export function OrdersList({ orders, pagelimit = 8, onOrderOpen,isLoading }) {
    const [currentPage, setCurrentPage] = useState(0);
    if (isLoading || !orders) {
        return (
            <div className="orders-list standard-comp standard-margin-top" style={{ textAlign: "center", padding: "2rem" }}>
                <Spinner />
            </div>
        );
    }
    const paginatedOrders = [];
    for (let i = 0; i < orders.length; i += pagelimit) {
        paginatedOrders.push(orders.slice(i, i + pagelimit));
    }

    var currentOrders = paginatedOrders[currentPage] || [];

    return (
        <>
            <div className="orders-list standard-comp standard-margin-top" style={{height: (pagelimit * 60) + "px"}}>
                { currentOrders.map((order) => {
                    return (
                        <div className="order-comp" onClick={() => onOrderOpen(order.id)}>
                            <div style={{flexGrow: 1}}>
                                <p className="order-title" style={{"display": "flex", gap: "0.5rem"}}>Bestelling #{ order.id } <Badge slim={true} badge="succes" label="Betaald" rounded={true} ></Badge></p>
                                <p className="order-description">{ order.description }</p>
                            </div>
                            <div style={{"textAlign": "right"}}>
                                <p className="order-description">{ order.orderingDate }</p>
                                <p className="order-description"><b>€ { order.price }</b></p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <HorizontalLayout style={{gap: "1rem", justifyContent: "center", marginTop: "1rem"}}>
                <StandardButton title="<" onClick={() => setCurrentPage(currentPage - 1)} isDisabled={currentPage === 0} />
                    { currentPage + 1 } / { paginatedOrders.length }
                <StandardButton style={{margin: "0px"}} title=">" onClick={() => setCurrentPage(currentPage + 1)} isDisabled={currentPage === paginatedOrders.length - 1} />
            </HorizontalLayout>
        </>
    )
}

export function CreditList({ orders, pagelimit = 8, onOrderOpen,isLoading }) {
    const [currentPage, setCurrentPage] = useState(0);
    if (isLoading || !orders) {
        return (
            <div className="orders-list standard-comp standard-margin-top" style={{ textAlign: "center", padding: "2rem" }}>
                <Spinner />
            </div>
        );
    }
    const paginatedOrders = [];
    for (let i = 0; i < orders.length; i += pagelimit) {
        paginatedOrders.push(orders.slice(i, i + pagelimit));
    }

    var currentOrders = paginatedOrders[currentPage] || [];
    var months = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
    return (
        <>
            <div className="orders-list standard-comp standard-margin-top" style={{height: (pagelimit * 60) + "px"}}>
                { currentOrders.map((order) => {
                    return (
                        <div className="order-comp">
                            <div style={{flexGrow: 1}}>
                                <p className="order-title" style={{"display": "flex", gap: "0.5rem"}}>Aantal credits: { order.total_credits }</p>
                                <p className="order-description">{ months[parseInt(order.date)-1] }</p>
                            </div>
                            <div style={{"textAlign": "right"}}>
                                <p className="order-description">totaal verbuikt { order.total_credits_used } en  { order.total_in_use } actief</p>
                                
                            </div>
                        </div>
                    )
                })}
            </div>
            <HorizontalLayout style={{gap: "1rem", justifyContent: "center", marginTop: "1rem"}}>
                <StandardButton title="<" onClick={() => setCurrentPage(currentPage - 1)} isDisabled={currentPage === 0} />
                    { currentPage + 1 } / { paginatedOrders.length }
                <StandardButton style={{margin: "0px"}} title=">" onClick={() => setCurrentPage(currentPage + 1)} isDisabled={currentPage === paginatedOrders.length - 1} />
            </HorizontalLayout>
        </>
    )
}